<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Laporan Sales Order {{ year }}</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" class="pa-3">
				<v-list-item dense class="px-1">
					<v-col cols="4" md="4">
						<v-autocomplete outlined dense hide-details v-model="year" :items="optionYear" label="Tahun" class="
						width-0"></v-autocomplete>
					</v-col>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-card outlined>
			<v-data-table :headers="header" dense :items="soAnnually" hide-default-footer :items-per-page="100">
				<template v-slot:item.product_name="{ item }">
					<div class="pt-2">{{ item.product_name }}</div>
				</template>
				<template v-slot:item.product_code="{ item }">
					<div class="pt-2">{{ item.product_code }}</div>
				</template>
				<template v-slot:item.januari="{ item }">
					<div class="pt-2">{{ item.penjualan[1] | toNumber}}</div>
				</template>
				<template v-slot:item.februari="{ item }">
					<div class="pt-2">{{ item.penjualan[2] | toNumber}}</div>
				</template>
				<template v-slot:item.maret="{ item }">
					<div class="pt-2">{{ item.penjualan[3] | toNumber}}</div>
				</template>
				<template v-slot:item.april="{ item }">
					<div class="pt-2">{{ item.penjualan[4] | toNumber}}</div>
				</template>
				<template v-slot:item.mei="{ item }">
					<div class="pt-2">{{ item.penjualan[5] | toNumber}}</div>
				</template>
				<template v-slot:item.juni="{ item }">
					<div class="pt-2">{{ item.penjualan[6] | toNumber}}</div>
				</template>
				<template v-slot:item.juli="{ item }">
					<div class="pt-2">{{ item.penjualan[7] | toNumber}}</div>
				</template>
				<template v-slot:item.agustus="{ item }">
					<div class="pt-2">{{ item.penjualan[8] | toNumber}}</div>
				</template>
				<template v-slot:item.september="{ item }">
					<div class="pt-2">{{ item.penjualan[9] | toNumber}}</div>
				</template>
				<template v-slot:item.oktober="{ item }">
					<div class="pt-2">{{ item.penjualan[10] | toNumber}}</div>
				</template>
				<template v-slot:item.november="{ item }">
					<div class="pt-2">{{ item.penjualan[11] | toNumber}}</div>
				</template>
				<template v-slot:item.desember="{ item }">
					<div class="pt-2">{{ item.penjualan[12] | toNumber}}</div>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
import {mapActions,  mapState,} from 'vuex'

const yearNow = new Date().getFullYear();

const yearStart = 2021

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			page: 1,
			limit: "10000",
			listLimit: [ '5', '10', '20', '50', '100' ],
			header: [
			{ text: 'Nama Produk', value: 'product_name' },
			{ text: 'Kode Produk', value: 'product_code' },
			{ text: 'Jan', value: 'januari', sortable: false},
			{ text: 'Feb', value: 'februari', sortable: false},
			{ text: 'Mar', value: 'maret', sortable: false},
			{ text: 'Apr', value: 'april', sortable: false},
			{ text: 'Mei', value: 'mei', sortable: false},
			{ text: 'Jun', value: 'juni', sortable: false},
			{ text: 'Jul', value: 'juli', sortable: false},
			{ text: 'Agu', value: 'agustus', sortable: false},
			{ text: 'Sep', value: 'september', sortable: false},
			{ text: 'Okt', value: 'oktober', sortable: false},
			{ text: 'Nov', value: 'november', sortable: false},
			{ text: 'Des', value: 'desember', sortable: false},
			],
			year: '',
			name: {
				value:'',
				comparison:'like',
				type:'string',
				field:'product_name'
			},
			params:[],
		}
	},
	computed: {
		...mapState('so', ['soAnnually']),

		optionYear() {
			let rangeYear = []
			for (var i = yearNow; i >= yearStart; i--) {
				rangeYear.push(i)
			}
			return rangeYear
		}
	},
	methods: {
		...mapActions('so', ['getSOAnually', 'exportSOAnually']),

		getData() {
			this.getSOAnually({year: this.year})
		},
		exportData(){
			this.exportSOAnually({year: this.year})
		},
		cari() {
			// this.params= []

			// if(this.code.value)
			// 	this.params.push(this.code)

			// if(this.name.value)
			// 	this.params.push(this.name)

			this.getData()
		},
		resetFilter() {
			this.code.value = ''
			this.name.value = ''
			this.params = []
			this.limit = 10
			this.getData()
		},
	},
	created() {
		this.year = yearNow
		this.getData()
		this.$store.dispatch('setPageTitle', `Penjualan Bulanan`)
	},
	watch: {
		page() {
			this.getData()
		},
		limit() {
			this.getData()
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>